import {inject, Injectable} from '@angular/core';
import {DefaultService} from '@common/references/default.service';
import {environment} from '@environments/environment';
import {RentalContract} from '@modules/universal-billing/contract/contract.interface';
import {TranslateService} from '@ngx-translate/core';
import {FullNamePipe} from '@common/pipe/full-name.pipe';
import {idField, ReferenceField} from '@common/references/reference-field';

@Injectable({
  providedIn: "root",
})

export class ContractsService extends DefaultService<RentalContract> {
  backendName = 'rental-contracts';
  title = 'MENU.PAYMENTS';
  translate = inject(TranslateService);
  fullNamePipe = new FullNamePipe();

  fields: ReferenceField[] = [
    idField,
    {fieldName: 'contractNumber', label: 'CONTRACTS.CONTRACT_NUMBER', filter: true, iconClass: 'ri-list-ordered'},
    {fieldName: 'contractType', label: 'APARTMENT.TYPE', filter: true, iconClass: 'ri-exchange-funds-line'},
    {fieldName: 'status', label: 'CITY.STATUS', viewType: 'status', filter: true, iconClass: 'las la-toggle-on'},
    {fieldName: 'startDate', label: 'PROPERTY.BEGIN', viewType: 'date', filter: true, iconClass: 'ri-time-line'},
    {fieldName: 'endDate', label: 'PROPERTY.END', viewType: 'date', filter: true, iconClass: 'ri-time-line'},
    {fieldName: 'totalRent', label: 'CONTRACTS.AMOUNT_MONTHLY', viewType:"money", filter: true, iconClass: 'ri-money-euro-circle-line'},
    {fieldName: 'actions', label: 'READINGS.ACTIONS', filter: true, iconClass: 'las la-cog'},

  ];

  hasActions = false;
  hasAdd = false;
  hasDelete = false;
  hasView=false;
  hasEdit=false;

  getUrl(): string {
    return environment.apiUrl + '/rental-contracts';
  }
}
